/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteSessionIssuer,
  RemoteSessionIssuer$inboundSchema,
} from "./remotesessionissuer.js";

/**
 * Result of refreshMetadata: the stored remote_session_issuer as it now stands, plus any warnings raised while re-reading the upstream RFC 8414 document. Distinct from RemoteSessionIssuerDraft, which describes an issuer that may not exist yet and is never persisted.
 */
export type RemoteSessionIssuerRefresh = {
  /**
   * Warnings describing any RFC 8414 deviations encountered while re-reading the issuer's metadata document. A refresh that returns warnings still persisted its result; deviations severe enough to distrust the document abort the refresh with an error instead.
   */
  discoveryWarnings: Array<string>;
  /**
   * A remote_session_issuer record — upstream Authorization Server identity that Speakeasy speaks OAuth to.
   */
  issuer: RemoteSessionIssuer;
};

/** @internal */
export const RemoteSessionIssuerRefresh$inboundSchema: z.ZodMiniType<
  RemoteSessionIssuerRefresh,
  unknown
> = z.pipe(
  z.object({
    discovery_warnings: z.array(z.string()),
    issuer: RemoteSessionIssuer$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "discovery_warnings": "discoveryWarnings",
    });
  }),
);

export function remoteSessionIssuerRefreshFromJSON(
  jsonString: string,
): SafeParseResult<RemoteSessionIssuerRefresh, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RemoteSessionIssuerRefresh$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoteSessionIssuerRefresh' from JSON`,
  );
}
